
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersNightColour as ObiRainShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-night-colour.js';
 
 
 

 
 export const ObiRainShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-rain-showers-night-colour',
   elementClass: ObiRainShowersNightColourElement,
   events: {
     
   }
  });
 
 